import { PropsWithChildren, useMemo } from 'react';

import { buildCampaignCountryMetadata } from '@features/campaigns/shared/providers/CampaignCountryProvider/buildCampaignCountryMetadata.ts';
import { CampaignCountryContext } from '@features/campaigns/shared/providers/CampaignCountryProvider/providerSetup.ts';
import { UserCountryCode } from '@shared/types/countryCodes.ts';

interface CampaignCountryProviderProps {
  countryCode: UserCountryCode;
}

export function CampaignCountryProvider({ countryCode, children }: PropsWithChildren<CampaignCountryProviderProps>) {
  const value = useMemo(() => buildCampaignCountryMetadata(countryCode), [countryCode]);

  return <CampaignCountryContext.Provider value={value}>{children}</CampaignCountryContext.Provider>;
}
